import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';

import { RegistrationPage } from './registration';
import { ComponentsModule } from '../../app/components/components.module';
import { UserModule } from '../../app/user/user.module';

@NgModule({
  declarations: [
    RegistrationPage,
  ],
  imports: [
    IonicPageModule.forChild(RegistrationPage),
    TranslateModule.forChild(),
    ComponentsModule,
    UserModule.forRoot(),

  ]
})
export class RegistrationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/registration/registration.module.ts